import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCheckBadgeGlyphSecondary from './svgs/CheckBadgeGlyphSecondary.js';
import SvgCheckBadgeGlyph from './svgs/CheckBadgeGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var checkBadgeGlyph = (props => useIcon(SvgCheckBadgeGlyph, SvgCheckBadgeGlyphSecondary, props));

export { checkBadgeGlyph as default };
